/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cloud_logic_custom": [
        {
            "name": "accountApiForgotPassword",
            "endpoint": "https://7ggpqvd229.execute-api.eu-west-1.amazonaws.com/staging",
            "region": "eu-west-1"
        }
    ]
};


export default awsmobile;
